import Games from '../../components/GameManagement/Games';

const GamesPage = () => {
	return <Games />;
};

export default GamesPage;
